/* eslint-disable  react/jsx-props-no-spreading */
import React from 'react';
import parse, { domToReact } from 'html-react-parser';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
import SvgDownload from '@digital-hig/icon/lib/esm/icons/download';
import { optimizeContentfulImage } from './utilities';

const parseHTMLString = ({ html, env }) => {
  const options = {
    replace: (domNode) => {
      const {
        attribs, children, type, name,
      } = domNode;
      if (!attribs) {
        return;
      }
      if (type === 'tag' && name === 'img') {
        // eslint-disable-next-line no-param-reassign
        domNode.attribs.src = optimizeContentfulImage({ url: domNode.attribs.src, env });
        // eslint-disable-next-line no-param-reassign
        domNode.attribs.loading = 'lazy';
        // eslint-disable-next-line consistent-return
        return domNode;
      }
      if (attribs.class === 'mce-adsk-btn-primary') {
        delete attribs.class;
        delete attribs.orientation;
        delete attribs.style;

        // eslint-disable-next-line consistent-return
        return (

          <Button
            {...attribs}
            variant="contained"
            size="defaultSize"
            style={{ fontSize: '1em' }}
            startIcon={(
              <SvgDownload
                id="dhig--icons--actions--download"
                title=""
              />
            )}
          >
            {domToReact(children, options)}
          </Button>
        );
      }
      if (attribs.class === 'mce-adsk-btn-secondary') {
        delete attribs.class;
        delete attribs.orientation;
        delete attribs.style;

        // eslint-disable-next-line consistent-return
        return (

          <Button
            {...attribs}
            variant="outlined"
            size="defaultSize"
            style={{ fontSize: '1em' }}
            startIcon={(
              <SvgDownload
                id="dhig--icons--actions--download"
                title=""
              />
            )}
          >
            {domToReact(children, options)}
          </Button>

        );
      }
      if (attribs.class === 'mce-custom-btn-normal') {
        delete attribs.class;
        delete attribs.orientation;
        delete attribs.style;

        // eslint-disable-next-line consistent-return
        return (

          <Button
            {...attribs}
            variant="text"
            size="defaultSize"
            style={{ fontSize: '1em' }}
            startIcon={(
              <SvgDownload
                id="dhig--icons--actions--download"
                title=""
              />
            )}
          >
            {domToReact(children, options)}
          </Button>

        );
      }
    },
  };

  return parse(html, options);
};

export default parseHTMLString;
